import { IApplicationState } from '../../types/redux';

export function selectPrimalRegions(state: IApplicationState) {
  const { regionInfo } = state;
  const { primalRegions } = regionInfo;

  return primalRegions;
}
